import { apiClient } from '../apiClient';
import { handleRequest } from '../apiWrapper';
import type { AssetPricesFilter, AssetPricesResponse } from '@/shared/types';

export const getAssetPrices = async (
  asset: string,
  filter?: AssetPricesFilter
): Promise<AssetPricesResponse> => {
  const request = () =>
    apiClient.get(`/assets/${asset}/prices`, {
      params: filter ? { filter } : undefined,
    });
  const response = await handleRequest<AssetPricesResponse>(request);
  return response.data;
};
